import { Button, Container, Typography } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import FadeIn from 'react-fade-in/lib/FadeIn'
const PilotSites = () => {

  return (
    <FadeIn transitionDuration="3000">
      <Typography variant="h3" style={{ color:'white' }}>Pilot Sites</Typography>
      <Container className="button-grid-container">
        <div style={{ margin: '10%' }}>
          <Button
            component={Link}
            to="/Pilot-sites/Areenainfo"
            style={{
              fontSize:'35px',
              color: 'white',
              background:'black',
              minWidth:'450px',
              border:'1px solid white',
              margin:'1%'
            }}
          >Lappi Areena</Button>
          <div className="Pilot-areas">
            <Typography variant="subtitle1">Lappi Areena is perfect for ice sports – ice offering is comprehensive with a total of three rinks: a competition hall and two training halls. There are 12 locker rooms in total, drying and laundry facilities. Competition hall can seat approx. 3500 people and there is also 9 private booths that fit up to 180 people in total. The ice rink can be converted into floor whereupon it has 1280 standing places.</Typography>
            <Typography variant="subtitle1" style={{ marginTop:'5%' }}>Lappi Areena is a modern multipurpose hall, which can quickly be transformed for different uses based on the needs of the event. Our professional staff makes it possible to organize all types of events, such as fairs, concerts and games. Together with our partners, we provide state-of-the-art sound system, lighting and A/V-technology from event planning to tear down phase. </Typography>
          </div>
        </div>
        <div style={{ margin: '10%' }}>
          <Button
            component={Link}
            to="/Pilot-sites/Ounasinfo"
            style={{
              fontSize:'35px',
              color: 'white',
              background:'black',
              minWidth:'450px',
              border:'1px solid white',
              margin:'1%'
            }}>Ounashalli</Button>
          <div className="Pilot-areas"><Typography variant="subtitle1">Ounashalli was opened in 1986 and it’s located right next to Santasport’s main building. The hall was renovated in 2008 and artificial turf (NSF Mondo Monofibre 11 60 AE Star) was added. At this time nets, goals (four pairs) and bulbs were changed also. The width of the hall is 62,6 m, length is 98,6 m and max. height is 13,5 m. The football field size is 51 m x 90 m. The hall has two sets of large goals and four small ones. There are four passing walls.</Typography></div>
        </div>
      </Container>
    </FadeIn>
  )
}

export default PilotSites